var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    viewBox: "0 0 72 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 35.7727C63 55.8182 36 73 36 73C36 73 9 55.8182 9 35.7727C9 28.9374 11.8446 22.382 16.9081 17.5487C21.9716 12.7153 28.8392 10 36 10C43.1608 10 50.0284 12.7153 55.0919 17.5487C60.1554 22.382 63 28.9374 63 35.7727Z",
    stroke: "#2A07F9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43C40.9706 43 45 38.9706 45 34C45 29.0294 40.9706 25 36 25C31.0294 25 27 29.0294 27 34C27 38.9706 31.0294 43 36 43Z",
    stroke: "#2A07F9",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.cc76052739a536b12c8bed809b75bdde.svg";
export { ForwardRef as ReactComponent };